import React from "react";

interface RecipeDirectionsProps {
  directions?: string;
}

const STEP_MARKER = /STEP\s*\d+\./i;

const RecipeDirections: React.FC<RecipeDirectionsProps> = ({ directions }) => {
  if (!directions) {
    return (
      <p className="py-4 text-center text-gray-500 dark:text-gray-400">
        No cooking directions provided for this recipe.
      </p>
    );
  }

  // Split directions into steps by markers like "STEP 1."
  const steps = directions.split(STEP_MARKER).filter((step) => step.trim());

  if (steps.length >= 1 && STEP_MARKER.test(directions)) {
    return (
      <div className="space-y-4">
        {steps.map((step, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-biafit-primary text-sm font-bold text-white">
              {index + 1}
            </div>
            <p className="pt-1 leading-relaxed text-gray-700 dark:text-gray-300">
              {step.trim()}
            </p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <p className="whitespace-pre-line leading-relaxed text-gray-700 dark:text-gray-300">
      {directions}
    </p>
  );
};

export default RecipeDirections;
